import React, { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styles from './AccountMenuItem.module.scss'
import { Text } from 'components/Text'
import cx from 'classnames'

type AccountMenuItemProps = {
  path: string
  text: string
}

export const AccountMenuItem: FC<AccountMenuItemProps> = (props) => {
  const location = useLocation()

  const classes = cx({
    [styles.isActive]: props.path === location.pathname,
    [styles.accountMenuItem]: styles.accountMenuItem,
  })

  return (
    <Link to={props.path} className={classes}>
      <Text align="right" weight="strong" className={styles.menuText} component="span">
        {props.text}
      </Text>
    </Link>
  )
}

AccountMenuItem.displayName = 'AccountMenuItem'
